import { Box, IconButton, Typography, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const SmsStatsBar = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background["paper-elevation-1"],
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadiusMd,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(3),
}));

export const StatsMetaGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(3),
}));

export const StatsActionsGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const SmsSegmentCountText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const CharacterCountText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "nearLimit",
})<{ nearLimit?: boolean }>(({ theme, nearLimit }) => ({
  color: nearLimit ? theme.palette.warning.dark : theme.palette.text.primary,
}));

export const AttachedMediaItem = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "60px",
  height: "60px",
  marginLeft: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadius}px`,
  backgroundColor: theme.palette.common.white,
  overflow: "hidden",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

export const AttachedDocumentItem = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(2),
  marginLeft: theme.spacing(3),
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 5, 2, 2),
  maxWidth: 260,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadius}px`,
  backgroundColor: theme.palette.common.white,
}));

export const AttachedMediaPreview = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: `${theme.shape.borderRadius}px`,
  display: "block",
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));

export const RemoveMediaButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 2,
  right: 2,
  width: 16,
  height: 16,
  minWidth: 16,
  minHeight: 16,
  backgroundColor: alpha(theme.palette.common.black, 0.52),
  color: theme.palette.common.white,
  lineHeight: 1,
  fontSize: 10,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.68),
  },
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 1,
  },
}));

export const EmojiPickerPopoverContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));
